import { MutationPayload } from 'vuex';
import { getTrackingDispatchers, TrackingEvent } from '@owc/connection-aem-tracking';
import { AnyAction } from 'redux';
import { PACKAGE_VERSION } from '../version';

export const PKG_VERSION: string = PACKAGE_VERSION || '0.0.0';
export interface TrackingFields {
  label: string;
  alias: string;
  payloadPath: string;
}
export interface TrackingDefinition<T extends TrackingFields = TrackingFields> {
  [type: string]: T;
}

interface MessageBus {
  pushTrackingEvent: (event: TrackingEvent) => AnyAction;
}

export abstract class Tracking<
  TrackingStructure extends TrackingEvent,
  State,
  TrackActions extends TrackingDefinition = TrackingDefinition,
> {
  constructor(
    protected readonly toTrackActions: TrackActions,
    private readonly lifecycleChannel: string,
    private readonly pluginInstance: string,
  ) {}

  /**
   * vuex subscription middleware function
   * @param mutation
   * @param state
   */
  public abstract trackMiddleware(mutation: MutationPayload, state: State): void;

  protected async publishTrackEvent(event: TrackingStructure): Promise<void> {
    const messageBus = await this.getTracker();
    messageBus.pushTrackingEvent(event);
  }

  private async getTracker(): Promise<MessageBus> {
    return getTrackingDispatchers();
  }

  protected getPayloadByStringDefinition<T>(mutation: MutationPayload, description: string): T {
    const tree = description.split('.');
    return tree.reduce<any>((obj, val) => {
      obj = obj[val];
      return obj;
    }, mutation);
  }
}
